import React from 'react'

export default function Toast({ children, title, mt }) {
    return (
        <div className="group relative flex justify-center">
            {children}
            <span className={"absolute hidden md:block bottom-10 shadow-xl scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 " + mt}>{title}</span>
        </div>
    )
}